import { Icon } from './Icon'
import { fmtDate } from '@/lib/format'
import { stageDef } from '@/lib/stages'
import type { TaskEvent } from '@/lib/types'

export function describeTaskEvent(e: TaskEvent): string {
  switch (e.type) {
    case 'task_retired': return 'Task retired'
    case 'task_restored': return 'Task restored'
    case 'authoring_resumed': return 'Build resumed'
    case 'content_edited': return 'Brief or agent prompt updated'
    case 'rubric_edited': return 'Rubric saved'
    case 'rubric_review_requested': return 'Expert rubric review requested'
    case 'rubric_review_returned': return 'Rubric review returned to developer'
    case 'peer_reviewed': return e.to_stage === 3 ? 'Peer approved the submission' : 'Peer returned the submission for changes'
    case 'coach_review_waived': return 'Engineer waived the coach review'
    case 'created': return 'Draft created'
    case 'transition': return e.action === 'send_back'
      ? `Sent back to “${stageDef(e.to_stage ?? 0, e.workflow_version).label}”`
      : `Moved to “${stageDef(e.to_stage ?? 0, e.workflow_version).label}”`
    case 'assigned': return String(e.message || 'Assigned')
    case 'review_edited': return 'Review saved'
    case 'build_edited': return 'Build status saved'
    case 'qc_edited': return 'Quality-check notes saved'
    case 'submission_edited': return `Submission notes saved${e.message ? ` (${e.message})` : ''}`
    case 'empty_start_changed': return String(e.message || 'Empty starting file changed')
    case 'file_uploaded': return `Uploaded ${e.message}`
    case 'file_revalidated': return `Re-checked ${e.message}`
    case 'file_deleted': return `Removed ${e.message}`
    case 'draft_edited': return 'Draft edited'
    case 'authoring_blocked': return 'The authoring agent reported a blocker'
    default: return e.type
  }
}

export function Timeline({ events }: { events: TaskEvent[] }) {
  if (events.length === 0) return <p className="muted small">No activity yet.</p>
  return (
    <ul className="timeline">
      {[...events].reverse().map((e, i) => (
        <li key={i}>
          <div>{describeTaskEvent(e)} <span className="muted small">· {e.actor_role === 'agent' ? <Icon name="agent" size={13} /> : null} {e.actor_email} · {fmtDate(e.at)}</span></div>
          {e.type === 'transition' && e.message && <div className="muted small prewrap">“{e.message}”</div>}
        </li>
      ))}
    </ul>
  )
}
